import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function relatorioHierarquiaEstruturaReducer(state = initialState.relatorioHierarquiaEstrutura, action){
    switch(action.type) {
        case types.RELAT_HIERARQUIA_ESTRUTURA:
            
            return action.relatorioHierarquiaEstrutura;
        default:
            return state;
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/reduces/relatorioHierarquiaEstruturaReducer.js
 **/